import { GraphQLErrors } from '@apollo/client/errors';
import { ApolloErrorCode } from '@src/enums/apolloErrorCode.enum';

export const getIsAuthError = (graphQLErrors: GraphQLErrors): boolean => {
  return graphQLErrors.some(error => {
    return error?.extensions?.exception?.status === 401 || error?.extensions?.code === ApolloErrorCode.UNAUTHENTICATED;
  });
};
